import { ownerDocument } from '../../../xmlUtility';
import {
    paramData,
    paramDsName,
    paramName,
    paramUpdate,
} from '../constants/parameterNames';
import { typeBoolean, typeDataSource } from '../constants/parameterTypes';
import { failure, success } from '../helpers/commandResult';
import {
    getBoolParamValue,
    getParamValue,
} from '../helpers/parameter.accessors';
import { getDataSource } from '../helpers/qRules.dataSource.helpers';
import { getPi } from '../helpers/qRules.node.helpers';

const description = 'Insert a processing instruction into the xml file.';

const requiredParameters = {
    [paramName]: {
        description: 'Name of the processing instruction to insert.',
    },
    [paramData]: {
        description: 'Data content of the processing instruction.',
    },
};

const optionalParameters = {
    [paramUpdate]: {
        description:
            "(boolean, defaults to false)\n\nWhen true, this command will replace the processing instruction if it already exists and add a new one if it doesn't.\n\nWhen false, the command will fail with an error if a processing instruction with the indicated name is already present.",
        type: typeBoolean,
    },
    [paramDsName]: {
        description:
            'Name of the data source to insert the processing instruction into.',
        type: typeDataSource,
    },
};

const insertpiErrorPiExists = 'The specified PI already exists.';

async function executeAsync({ dataSources, parameters }) {
    const name = getParamValue(parameters, paramName);
    const data = getParamValue(parameters, paramData);
    const update = getBoolParamValue(parameters, paramUpdate);
    const dsName = getParamValue(parameters, paramDsName);
    const dom = getDataSource(dataSources, dsName);
    let existingPi = getPi(dom, name);

    if (existingPi) {
        if (!update) {
            return failure(insertpiErrorPiExists);
        }

        existingPi.deleteSelf();
    }

    const xdoc = ownerDocument(dom.getNode());
    const newPi = xdoc.createProcessingInstruction(name, data);

    try {
        const rootElement = dom.selectSingle('/*');

        await rootElement.insertBeforeAsync(newPi);

        return success();
    } catch (e) {
        return failure('Error occurred trying to insert PI: ' + e.message);
    }
}

const InsertPi = {
    description,
    executeAsync,
    optionalParameters,
    requiredParameters,
};

export default InsertPi;
